import { useContext, useMemo } from 'react';
import { AppContext } from '@/context/AppContext';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { buildCompetitorData } from '@/utils/pdfUtils';
import PageHeader from '@/components/shared/PageHeader';

export default function CompetitorChart() {
  const { rankings, activeClientId } = useContext(AppContext);

  const competitorData = useMemo(() => {
    const clientRankings = rankings[activeClientId] || [];
    return buildCompetitorData(clientRankings);
  }, [rankings, activeClientId]);

  if (competitorData.length === 0) return null;

  return (
    <div className="card p-6" data-testid="competitor-chart">
      <PageHeader label="Competitor Landscape" />
      
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={competitorData}
            layout="vertical"
            margin={{ top: 0, right: 20, left: 0, bottom: 0 }}
          >
            <XAxis type="number" hide />
            <YAxis 
              type="category" 
              dataKey="domain" 
              width={150}
              tick={{ 
                fill: '#94A3B8', 
                fontSize: 11, 
                fontFamily: 'JetBrains Mono, monospace' 
              }}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: '#131926',
                border: '1px solid #1E2D45',
                borderRadius: '8px',
                fontSize: '12px',
                fontFamily: 'Syne, sans-serif',
              }}
              labelStyle={{ color: '#E2E8F0', fontWeight: 'bold' }}
              itemStyle={{ color: '#00C48C' }}
              formatter={(value) => [`${value} appearances`, 'Count']}
            />
            <Bar 
              dataKey="count" 
              radius={[0, 4, 4, 0]}
              maxBarSize={30}
            >
              {competitorData.map((entry, index) => (
                <Cell 
                  key={`cell-${index}`} 
                  fill={index === 0 ? '#0070F3' : '#1E2D45'} 
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
